import type { PublicSlotKey } from '@/apilib';
import type { HistoryApi } from './api';

export const HistoryApiKey: PublicSlotKey<HistoryApi> = {
  name: 'HistoryApi',
  public: true,
};
